// extracted by mini-css-extract-plugin
module.exports = {"benefitsWrapper":"Benefits_benefitsWrapper__RgXcd","container":"Benefits_container___DKXz","iconContainer":"Benefits_iconContainer__drSke","title":"Benefits_title__vCsnv"};